// Copyright (c) 2026 PGNS LLC

import { useEffect, useState } from 'react';

/**
 * A clock that ticks so relative ages ("checked 12s ago") keep counting between
 * polls instead of freezing at whatever they were when the data arrived.
 */
export function useNow(intervalMs = 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    const timer = setInterval(() => setNow(Date.now()), intervalMs);
    return () => clearInterval(timer);
  }, [intervalMs]);
  return now;
}
